export const isDa = () => {
  return import.meta.env.VITE_TENANT === 'da'
}

export const isZur = () => {
  return import.meta.env.VITE_TENANT === 'zur'
}

export function isTrue(value: string | boolean): boolean {
  return value?.toString().toLowerCase() === 'true'
}

export function removeDuplicateSlashesInString(url: string): string {
  return url.replaceAll(/\/+/g, '/')
}

export function startsWithOneOf(value: string, prefixes: string[]): boolean {
  return prefixes.some((prefix) => value.startsWith(prefix))
}
